<template>
  <div class="distriibution">
    <div class="ani logo" swiper-animate-effect="fadeIn" swiper-animate-duration="0.5s">
      <a href="#home">
        <img src="../assets/logo.png">
      </a>
    </div>
    <div class="distriibution-con">
      <div class="distriibution-text">
        <h2 
          class="ani"
          swiper-animate-effect="fadeInUp"
          swiper-animate-duration="1.5s"
        >NETWORK</h2>
        <!-- <p class="ani" swiper-animate-effect="fadeInUp" swiper-animate-duration="1.5s"  swiper-animate-delay="0.3s">After seven years of continuous efforts, I have opened eight branches in Guangzhou, Ningbo, Yiwu and Wuhan.Of course, this is just a small step toward becoming a global freight forwarder. The road ahead is still long</p> -->
        <ul class="distriibution-list">
          <li
            class="ani"
            v-for="(item,index) in disList"
            :key="index"
            swiper-animate-effect="fadeInUp"
            swiper-animate-duration="1s"
            :swiper-animate-delay="index/8+'s'"
          >{{item}}</li>
        </ul>
      </div>
      <div class="distriibution-group">
        <!-- <img src="../assets/group.png" > -->
        <echarts></echarts>
      </div>
    </div>
  </div>
</template>

<script>
import Echarts from "../components/Echarts";
export default {
  name: "distriibution",
  data() {
    return {
      disList: [
        "Baltic Sea",
        "West & North Europe",
        "Black Sea",
        "East Mediterranean & Adriatic",
        "Latin America",
        "North Africa",
        "India & Pakistan/South East & Far East Asia",
        "Middle East/Red Sea/Middle Asia",
        "East/West/South Africa",
        "West Mediterranean",
        "North America",
        "Oceania & Pacific Islands"
      ]
    };
  },
  components: {
    Echarts
  }
};
</script>

<style>
.distriibution,
.distriibution-con {
  height: 100%;
}
.distriibution-con {
  background: url(../assets/distriibution.jpg) no-repeat;
  background-size: cover;
  position: relative;
}
.distriibution-text {
  position: absolute;
  top: 30%;
  left: 6%;
  width: 60%;
}
.distriibution-text h2 {
  padding: 30px 0 30px 75px;
  font-size: 56px;
  color: #f4f4f4;
  background: url(../assets/market.png) no-repeat left center;
  background-size: 500px;
  position: relative;
  z-index: 99;
}
.distriibution-text p {
  color: rgba(255, 255, 255, 0.6);
  margin-left: 80px;
  max-width: 500px;
  line-height: 1.8;
}
.distriibution-group {
  position: absolute;
  top: 10%;
  right: 5%;
  width: 55%;
}
.distriibution-group img {
  width: 100%;
}
.distriibution-list {
  color: #f4f4f4;
  margin-left: 100px;
}
.distriibution-list li {
  list-style: disc;
}
@media screen and (max-width: 992px) {
  .distriibution-group {
    width: 100%;
    top: 0%;
    right: 0;
  }
  .distriibution-text {
    width: 100%;
    left: 0;
    top: 32%;
  }
  .distriibution-text h2 {
    font-size: 30px;
    background-size: 70%;
    text-align: center;
    background-position: center;
    padding: 12px 0;
  }
  .distriibution-text p {
    margin: 0;
    padding: 0 20px;
  }
  .distriibution-list {
    margin-left: 80px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Distribution.vue